// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content { min-width: 280px; }
.mat-dialog-actions { justify-content: flex-end; }
.progress {
   height: 3px;
   margin-top: 1em;
   opacity: 0;
}
.message {
   word-wrap: break-word;
}
.visible { opacity: 1 }
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}
::ng-deep .mat-button-focus-overlay {
   background-color:transparent !important;
}

.word-wraper {
   overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/confirm-delete/confirm-delete.component.css"],"names":[],"mappings":"AAAA,sBAAsB,gBAAgB,EAAE;AACxC,sBAAsB,yBAAyB,EAAE;AACjD;GACG,WAAW;GACX,eAAe;GACf,UAAU;AACb;AACA;GACG,qBAAqB;AACxB;AACA,WAAW,WAAW;AACtB;GACG,wBAAwB;AAC3B;AACA;GACG,uCAAuC;AAC1C;;AAEA;GACG,yBAAyB;AAC5B","sourcesContent":[".mat-dialog-content { min-width: 280px; }\n.mat-dialog-actions { justify-content: flex-end; }\n.progress {\n   height: 3px;\n   margin-top: 1em;\n   opacity: 0;\n}\n.message {\n   word-wrap: break-word;\n}\n.visible { opacity: 1 }\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n::ng-deep .mat-button-focus-overlay {\n   background-color:transparent !important;\n}\n\n.word-wraper {\n   overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
